<template>
    <div class="final-equation">
        <!-- <header-default :infos="true"></header-default> -->
        <!-- <div class="button-back" @click="backGame()" @touch="backGame()">
            voltar &rsaquo;
        </div> -->
        <div class="back_option" @click="backGame()" @touch="backGame()">
            <img src="/img/icons/back.png" alt="">
            <span>{{$t("views.FinalEquation.back")}}</span>
        </div>
        <div class="equation">
            <span 
                :class="[caracter.letter ? 'letter' : 'caracter',caracter.caracter == '*' ? 'asterisk' : ''] "
                :teste="caracter.caracter"
                v-for="(caracter, index) in arrayEquation" 
                :key="index">
                {{caracter.caracter}}
            </span>
        </div>
        <span class="value-warning">{{$t("views.FinalEquation.valueWarning[0]")}} <strong>{{$t("views.FinalEquation.valueWarning[1]")}}</strong></span>
        <div class="input-final-equation">
            <input @submit.prevent="finalGame()"
                    @keyup.enter="finalGame()" 
                    type="number"  
                    class="input-final" 
                    :placeholder='$t("views.FinalEquation.inputFinalEquation")'
                    ref="inputFinal">
        </div>
        <div class="buttons-equation">
            <!-- <div class="button-send" @click="backGame()" @touch="backGame()">
                <button-default classButton="final-equation" textButton="voltar"></button-default>
            </div> -->
            <div class="button-send" @click="finalGame()" @touch="finalGame()">
                <button-default :buttonLoader="buttonLoader" classButton="final-equation" :textButton='$t("views.FinalEquation.buttonSendFinalEquation")'></button-default>
            </div>
        </div>
        <!-- <div class="rules-list">
            <p class="rule">Resposta apenas com números;</p>
            <p class="rule">Cada tentativa custará $1000;</p>
        </div> -->
        <div class="attempts">
            <div class="title-attempts">{{$t("views.FinalEquation.titleAttempts")}}</div>
            <div class="list-attempts">
                <ul class="list">
                    <li class="attempt" v-for="attempt in finalAttempts" :key="attempt.attempt">
                        <img src="../assets/xis-small.png" alt="" class="xis">
                        <span class="attempt-span">{{attempt.attempt}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="message-error" v-if="messageError">
            <img v-show="messageError" src="../assets/feedback-wrong.gif" alt="">
        </div>
        
    </div>
</template>
<script>
import HeaderDefault from '../components/Sections/HeaderDefault.vue'
import ButtonDefault from '../components/Buttons/ButtonDefault.vue'
import decodeApi from '../api/decode.js'
import { setTimeout } from 'timers';
export default {
    components : {
        HeaderDefault,
        ButtonDefault
    },
    props: {
        equationFinal: {
            type : String,
            required : true
        },
        finalAttempts: {
            required : true
        }
    },
    data(){
        return{
            buttonLoader : false,
            messageError : false,
            request : false
        }
    },
    computed: {
        arrayEquation(){
            let arrayEquation = []
            if(this.equationFinal){
                let equationSplit = this.equationFinal.split(' ')
                equationSplit.forEach(caracter => {
                    if(caracter == 'a' || caracter == 'b' || caracter == 'c'){
                        arrayEquation.push({caracter, letter : true})
                        return 
                    }
                    arrayEquation.push({ caracter, letter : false})
                    return 
                })
            }
            return arrayEquation
        }
    },
    methods:{
        backGame(){
            this.$router.push('/game')
        },
        async finalGame(){
            if(this.request){
                return
            }
            this.request = true
            this.buttonLoader = true
            let input = this.$refs.inputFinal
            const { teamGameId, userId, score } = this.$store.getters.getSimple(["teamGameId", "userId", "score"])
            if(input.value == ''){
                this.$toaster.warning(this.$t("views.FinalEquation.toasterWarnings[0]"))
                this.request = false
                this.buttonLoader = false
                return
            }
            if(score <= 0){
                this.$toaster.warning(this.$t("views.FinalEquation.toasterWarnings[1]"))
                this.request = false
                this.buttonLoader = false
                input.value = ''
                return
            }
            const equalAttempt = await this.verifyFinalAttempts(parseInt(input.value))
            if(equalAttempt){
                this.$toaster.warning(this.$t("views.FinalEquation.toasterWarnings[2]"))
                this.request = false
                this.buttonLoader = false
                input.value = ''
                return
            }
            
            const response = await decodeApi.patch(`/team-games/${teamGameId}/attempt`, {
                attempt : parseInt(input.value),
                enigmaOrder : 'equation',
                userId
            })
            
            if(!response.data.correct) this.alertError()
            try {
                this.$toaster.success(this.$t("views.FinalEquation.toasterWarnings[3]"))
                input.value = ''
                this.request = false
                this.buttonLoader = false
            } catch (error) {
                //TODO: make a error message showing up instead console.log error
                // console.log(error)
            }
        },
        verifyFinalAttempts(newAttempt){
            const equalAttempt = this.finalAttempts.some(attempt => {
                return attempt.attempt == newAttempt
            })

            return equalAttempt
        },
        alertError(){
            let self = this
            this.messageError = true
            setTimeout(function(){
                self.messageError = false
            }, 2000)
        }
    }
}
</script>
<style lang="scss" scoped>
    .final-equation{
        background-color: #2f353a;
        height: 100vh;
        min-width: 100%;
        display: flex;
        flex-direction: column;

        .value-warning{
            text-align: center;
            width: 80%;
            margin: 0 auto 32px;
            color: #fff;
        }

        .back_option{
            display: flex;
            align-items: center;
            padding: 100px 15px 0;

            img{
                max-width: 32px;
                margin-right: 10px;
            }
            span{
                text-transform: uppercase;
                font-size: 13px;
                font-weight: 700;
                letter-spacing: 2px;
                color: #fff;
            }
        }        

        .button-back{

            position: absolute;
            top: 92px;
            left: -20px;
            transform: rotate(-90deg);
            background-color: #2f353a;
            width: 100px;
            height: 25px;
            color:#7600a8;
            font-weight: bold;
            text-align: center;
            font-size: 12px;
            text-transform: uppercase;
            padding-top: 5px;
            letter-spacing: 1px;
            cursor: pointer;
        }

        .equation{

            width: 55%;
            padding: 10% 0 5%;
            text-align: center;
            display: flex;
            align-items: center;
            margin: 0 auto;
            justify-content: space-around;
            background-color: #2f353a;
            
            .letter{

                color: #ffffff;
                font-weight: 900;
                font-size: 80px;
                text-transform: uppercase;
                
            }

            .caracter{

                color: white;
                text-shadow: none;
                font-size: 75px;
                font-weight: 700;
                vertical-align: middle;
            }
            .caracter.asterisk{
                position: relative;
                top: 20px;
            }
        }

        .input-final-equation{

            width: 75%;
            margin: 0 auto;
            background-color: #2f353a;

            .input-final{

                width: 100%;
                background-color: #000;
                border: none;
                border-radius: 45px;
                padding: 5%;
                text-align: center;
                outline: none;
                color: rgb(255, 255, 255);
                font-size: 35px;
                font-weight: 600;

                &::placeholder{
                    font-weight: 200;
                    font-size: 15px;
                    color: rgb(255, 255, 255);
                    position: relative;
                    bottom: 4px;
                }
            }
        }

        .buttons-equation{

            width: 100%;
            // margin: 10% auto;
            display: flex;
            justify-content: space-between;
            background-color: #2f353a;

            .button-send{

                width: 40%;
                background-color: #2f353a;
                margin: 0 auto;
                padding: 8% 0;
            }
        }

        .rules-list{

            width: 100%;
            height: 20%;
            margin: 0 auto;
            text-align: center;
            background-color: #2f353a;
            padding-bottom: 10px;
    

            .rule{

                margin-top: 4px;
                color: rgb(212, 212, 212);
                font-size: 12px;
            }
        }

        .attempts{

            // position: absolute;
            // bottom: 0px;
            width: 100%;
            background-color: #2f353a;
            position: absolute;
            bottom: 0;

            .title-attempts{

                background-color: black;
                width: 100%;
                color: rgb(212, 212, 212);
                font-size: 9px;
                height: 30px;
                text-transform: uppercase;
                display: flex;
                align-items: center;
                justify-content: center;
                letter-spacing: 1px;


            }

            .list-attempts{

                background-color: #23272b;

                .list{

                    display: flex;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    white-space: nowrap;
                    list-style: none;
                    margin: 0 auto;
                    width: 90%;

                    .attempt{
                        margin: 1% 30px 1% 0;
                        color: white;
                        font-size: 0.8em;
                        display: flex;
                        align-items: center;
                        height: 40px;

                        .xis{

                            height: 20px;
                            margin-right: 15%;
                        }

                        .attempt-span{

                            margin-top: 2px;
                             margin-right: 10px;
                        }
                    }
                }
            }
        }
        .message-error{
            background-color: #313131a3;
            position: absolute;
            top: -10vh;
            z-index: 1000;
            height: 110vh;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img{   
                height: 300px;
            }   
        }
    }

    @media only screen and (min-width: 750px){
        .final-equation{

            max-height: 600px;
            height: 100%;

            .equation{

                width: 25%;
                padding: 5% 0;
            }

            .input-final-equation{

                display: flex;
                justify-content: center;

                .input-final{

                    padding: 2%;
                    width: 70%;
                }
            }

            .buttons-equation{

                margin: 5% auto;
                width: 45%;
            }

            .rules-list{

                width: 60%;
                margin: 0 auto;
                text-align: center;

                .rule{

                    margin-top: 5%;
                }
            }

            .attempts{
                .list-attempts{
                    .list{
                        overflow-x: auto;
                        min-height: 55px;
                    }
                }
            }

            .message-error{
                height: 100%;
                max-height: 600px;
                top: 0;
            }
        }
    }
</style>
